import React from 'react';

import DataTable, { EmptyState } from '../DataTable';

import { formatAmount, formatDateTime } from '../../utils';

// The list endpoint returns a bare row list (no eager-loaded order/agent/
// customer), so we render the scalar foreign keys (order_id, agent_id) directly
// rather than reaching into nested objects. Row numbering is per-page (keyset
// pagination has no absolute page offset).
function RequestTable(props) {
  const {
    rows,
    loading,
    onRowClick = () => {},
    exclude = [],
    card = true,
    footer,
    error,
    onRetry,
    page,
    total,
    onPageChange,
  } = props;
  const columns = exclude.includes('gateway') ? 9 : 10;

  return (
    <DataTable
      card={card}
      loading={loading}
      minWidth={1000}
      footer={footer}
      page={page}
      total={total}
      onPageChange={onPageChange}
    >
      <thead className="text-primary">
        <tr>
          <th>No.</th>
          <th>Date</th>
          <th>Reference</th>
          <th>Meter No</th>
          {!exclude.includes('gateway') && <th>Gateway</th>}
          <th>Amount</th>
          <th>Order ID</th>
          <th>Type</th>
          <th>Agent ID</th>
          <th>Status</th>
        </tr>
      </thead>
      {!loading && error ? (
        <EmptyState
          colSpan={columns}
          icon={false}
          heading="Something went wrong"
          message={error}
          actionLabel="Retry"
          onAction={onRetry}
        />
      ) : (
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr
              onClick={() => onRowClick(row)}
              key={row.id}
              style={{ cursor: 'pointer' }}
            >
              <td>{loading ? '—' : rowIndex + 1}</td>
              <td>{formatDateTime(row.created_at)}</td>
              <td>{row.reference}</td>
              <td>{row.customer_ref}</td>
              {!exclude.includes('gateway') && <td>{row.gateway}</td>}
              <td>{formatAmount(row.amount)}</td>
              <td>{row.order_id}</td>
              <td>{row.plan}</td>
              <td>{row.agent_id}</td>
              <td>{row.status}</td>
            </tr>
          ))}
        </tbody>
      )}
    </DataTable>
  );
}

export default RequestTable;
